// Détection de langue — module pur (Phase 95, I18N-01).
//
// Ni React, ni window, ni supabase : l'appelant (le provider) lit l'objet
// global du butineur et passe le tableau de balises en argument. C'est ce qui
// rend I18N-01 prouvable sans dépendre de jsdom, qui annonce `en-US` par
// défaut et masquerait un repli français cassé.
// Refs: phase 95.
import type { Lang } from './types'

const SUPPORTED: readonly Lang[] = ['fr', 'en']

/** Le studio est à Paris : quand rien n'est reconnu, le français fait foi. */
export const DEFAULT_LANG: Lang = 'fr'

/**
 * Réduit une balise BCP-47 (`fr-CA`, `EN-us`) à une langue supportée.
 * Rend `null` — pas le repli — sur tout ce qui n'est pas servi : c'est
 * l'appelant qui décide quoi faire d'une absence de correspondance.
 */
export function normalizeLang(tag: string | null | undefined): Lang | null {
  if (!tag) return null
  const base = tag.split('-')[0].toLowerCase()
  return (SUPPORTED as readonly string[]).includes(base) ? (base as Lang) : null
}

/**
 * Première balise supportée de la liste, sinon le français.
 *
 * L'appelant doit passer `navigator.languages` (la liste ORDONNÉE de
 * préférence), pas `navigator.language` seul : un visiteur configuré
 * `['de-DE','en-GB','fr']` veut l'anglais, et la balise unique le ferait
 * tomber sur le repli français.
 */
export function detectFromNavigator(tags: readonly string[]): Lang {
  for (const tag of tags) {
    const lang = normalizeLang(tag)
    if (lang) return lang
  }
  return DEFAULT_LANG
}
